import { render, staticRenderFns } from "./MianLayout.vue?vue&type=template&id=bb7bf5de&"
import script from "./MianLayout.vue?vue&type=script&lang=js&"
export * from "./MianLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports